import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import logo from '../../../images/logo1.svg';
import dummyUser from '../../../models/User';
import { authenticateUser } from '../../../redux/actions/auth/AuthActions';

function Login({ history, authStatus, authenticateUser}){
    const [user, setUser] = useState(dummyUser);
    const location = useLocation();
    const redirectPath = location.state?.from || '/';

    useEffect(() => {
        console.log('location state', location.state);
        if (redirectPath !== '/') {
            toast.error('Login to visit admin pages!');
        }
    }, []);

    const handleLogin = (e) => {
        e.preventDefault();
        // const authUser = JSON.parse(localStorage.getItem('user'));
        // console.log(authUser, user);
        authenticateUser(user);
        // if(authUser.password === user.password) {
        //     localStorage.setItem('isLoggedIn', 'true');
        // } else {
        //     toast.error('Invalid credentials given!');
        // }
        // history.push({
        //     pathname: redirectPath
        // });
    };

    useEffect(() => {
        console.log('authStatus', authStatus);
        if (authStatus === 'authenticated') {
            localStorage.setItem('isLoggedIn', 'true');
            localStorage.setItem('user', JSON.stringify(user));
            history.push({
                pathname: redirectPath
            });
        } else if(authStatus.length > 0){
            toast.error(authStatus);
        }
    }, [authStatus]);

    return(
        <div>
            <section className="container-fluid maindiv mt-5">
                <div className="container formdiv my-5 d-flex shadow">
                    <img src={logo} className="formimg"></img>
                    <form className="myform mt-4" onSubmit={handleLogin}>
                        <div className="form-group mt-2">
                            <label htmlFor="exampleUserName">User Name</label>
                            <input value={user.username} onChange={(e) => setUser({ ...user, username: e.target.value })} type="text" className="form-control" id="exampleUserName" required />
                        </div>
                        <div className="form-group mt-2">
                            <label htmlFor="examplePassword">Password</label>
                            <input value={user.password} onChange={(e) => setUser({ ...user, password: e.target.value })} type="password" className="form-control" id="examplePassword" required />
                        </div>
                        <br></br>
                        <button type="submit" className="btn btn-primary">Submit</button>
                        <p className="mt-3">First time here?<span><Link to="/auth/signup"> Create Account </Link></span></p>
                    </form>
                </div>
            </section>
            <ToastContainer />
        </div>
    );
}

const mapStateToProps = (state) => {
    console.log('state', state);
    return {
        authStatus: state.auths,
    };
};

const mapDispatchToProps = {
    authenticateUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);